import { ReactNode, useCallback, useState } from "react";
import { Button, Collapse, List, Typography } from "antd";
import { useParams } from "react-router-dom";
import { ArrowIcon } from "@/shared/ui";
import { useNavigate, routes } from "@shared/lib/react-router";
import "./project-related-contracts.scss";

const { Panel } = Collapse;
const { Text, Title } = Typography;

const data = [
  {
    id: 1,
    title:
      "РТК-10/21 Комплекс работ по укрытию защитной сеткой существующих ветхих зданий имущественного комплекса нефтемаслозавода",
    isNested: true,
    nestedItems: [
      "ГКО-639/22 Комплекс строительно-монтажных работ по свайному основанию...",
      "ГКО-713/20 (КН-112/20) Монтаж ограждения",
      "ГКО-668/22 Комплекс строительно-монтажных работ...",
    ],
  },
  {
    id: 2,
    title: "РТК-15/22 (ГКО-757/22)",
    isNested: true,
    nestedItems: [
      "ГКО-639/22 Комплекс строительно-монтажных работ по свайному основанию...",
      "ГКО-713/20 (КН-112/20) Монтаж ограждения",
      "ГКО-668/22 Комплекс строительно-монтажных работ...",
    ],
  },
  {
    id: 3,
    title:
      "ГКО-668/22 Комплекс строительно-монтажных работ по устройству временных дорог, разработке котлована, устройству шпунтового ограждения котлована с распорной системой",
    isNested: false,
  },
];

export const ProjectRelatedContracts = () => {
  const navigate = useNavigate();
  const [expandedKeys, setExpandedKeys] = useState<number[]>([]);

  const handleContractClick = () => {
    navigate(routes.general.related(projectId));
  };

  const toggleAll = () => {
    if (expandedKeys.length === data.filter((item) => item.isNested).length) {
      setExpandedKeys([]);
    } else {
      setExpandedKeys(
        data.filter((item) => item.isNested).map((item) => item.id),
      );
    }
  };

  const handlePanelChange = (key: number) => {
    if (expandedKeys.includes(key)) {
      setExpandedKeys(expandedKeys.filter((id) => id !== key));
    } else {
      setExpandedKeys([...expandedKeys, key]);
    }
  };

  const { projectId } = useParams();

  const getExpandIcon = useCallback(
    ({ isActive = false }) => <ArrowIcon isActive={isActive} />,
    [],
  );

  return (
    <>
      <div className="project-related-title-container">
        <Title
          style={{
            fontSize: "20px",
            color: "#333333",
            fontWeight: "500",
            marginTop: "24px",
            marginBottom: "24px",
          }}
        >
          Договоры проекта
        </Title>
        <Button onClick={toggleAll} type="link">
          Свернуть/Развернуть все
        </Button>
      </div>

      <div className="project-related-contracts">
        <List
          dataSource={data}
          renderItem={(item) =>
            item.isNested ? (
              <Collapse
                ghost
                activeKey={expandedKeys}
                onChange={() => handlePanelChange(item.id)}
                expandIcon={getExpandIcon}
              >
                <Panel
                  header={<Text>{item.title}</Text>}
                  key={item.id}
                  style={{ border: "none" }}
                >
                  <List
                    dataSource={item.nestedItems}
                    renderItem={(nestedItem) => (
                      <span
                        onClick={handleContractClick}
                        className="project-related-link-wrapper project-related-link-wrapper--nested"
                      >
                        <Text className="project-related-link">
                          {nestedItem as ReactNode}
                        </Text>
                      </span>
                    )}
                  />
                </Panel>
              </Collapse>
            ) : (
              <List.Item>
                <span
                  onClick={handleContractClick}
                  className="project-related-link-wrapper"
                >
                  <Text className="project-related-link not-nested">
                    {item.title}
                  </Text>
                </span>
              </List.Item>
            )
          }
        />
      </div>
    </>
  );
};
